import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IInfoPagesStrings extends LocalizedStringsMethods {
    lsPrivacyPolicyTitle: string;
    lsLastModifiedTxt: string;
    lsContactUsTitle: string;
    lsContactUsContentTxt: string;
    lsTermsTitle: string;
}

let strings: IInfoPagesStrings;
export default strings = new LocalizedStrings({
    en: {        
        lsPrivacyPolicyTitle: 'Privacy Policy',
        lsLastModifiedTxt: 'Last modified',
        lsContactUsTitle: 'Contact EyeGuide',
        lsContactUsContentTxt: 'If you need to speak to an EyeGuide team member, ' + 
        'please send an email to support@eye.guide.',
        lsTermsTitle: 'Terms & Conditions'

    },
    es: {        
        lsPrivacyPolicyTitle: 'Privacy Policy',
        lsLastModifiedTxt: 'Last modified',
        lsContactUsTitle: 'Contact EyeGuide',
        lsContactUsContentTxt: 'If you need to speak to an EyeGuide team member, ' + 
        'please send an email to support@eye.guide.',
        lsTermsTitle: 'Terms & Conditions'
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/login/infoPages.tsx